import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../../core/reducers';
import { UserActionTypes } from '../_actions/user.actions';

@Injectable()
export class UserEffects {
    showPageLoadingDistpatcher;
    hidePageLoadingDistpatcher;
    showActionLoadingDistpatcher;
    hideActionLoadingDistpatcher;

    @Effect({ dispatch: false })
    loadUsersPage$ = this.actions$.pipe(
        ofType(UserActionTypes.UsersPageRequested),
        mergeMap(() => EMPTY)
    );

    @Effect({ dispatch: false })
    deleteUser$ = this.actions$.pipe(
        ofType(UserActionTypes.UserDeleted),
        mergeMap(() => EMPTY)
    );

    @Effect({ dispatch: false })
    updateUser$ = this.actions$.pipe(
        ofType(UserActionTypes.UserUpdated),
        mergeMap(() => EMPTY)
    );

    @Effect({ dispatch: false })
    createUser$ = this.actions$.pipe(
        ofType(UserActionTypes.UserOnServerCreated),
        mergeMap(() => EMPTY)
    );

    constructor(private actions$: Actions, private store: Store<AppState>) {}
}
